import { bg } from "styles/theme"
import { createContext, useContext } from "react"
import { ReactComponent as SearchIcon } from 'assets/icons/Search.svg';
import { SvgIcon } from "@mui/material"

// 1. יצירת קונטקסט ריק שישמש כברירת מחדל כדי למנוע קריסות
const EmptyContext = createContext({});

const useSearchFilter = (Context) => {
    const SafeContext = Context || EmptyContext;
    const context = useContext(SafeContext)
    const { handleSearch, searchValue, setSearchValue } = context || {}


    const searchInput = {
        placeholder: "חיפוש",
        input: {
            value: searchValue,
            onChange: setSearchValue
        },
        type: "regular",
        startAdornment: {
            component: () => <SvgIcon component={SearchIcon} color="#00000026" inheritViewBox />
        },
        bg: bg,
        onKeyDown: (event) => {
            if (event.key === 'Enter')
                handleSearch()
        },
        width: 100
    }

    const searchButton = {
        variant: "contained",
        className: "solid-round2",
        // disabled={!searchValue}
        color: "thirdly2",
        height: '40px',
        width: '63px',
        action: handleSearch,
        label: "חיפוש"
    }

    return { searchInput, searchButton }
}

export default useSearchFilter